/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Seo_Title1Inputs */

const vi_cmspost_seo_title1 = /** @type {(inputs: Cmspost_Seo_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề SEO (để trống = tiêu đề bài)`)
};

/**

* @param {Cmspost_Seo_Title1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_seo_title1 = /** @type {((inputs?: Cmspost_Seo_Title1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Seo_Title1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_seo_title1(inputs)
});
export { cmspost_seo_title1 as "cmsPost_seo_title" }